import { IrisService } from '@app/core/services/iris.service';
import { BankConsentTimelineActivityEventComponent } from './bank-consent-timeline-event-icon';
import { BankConsentsActivityComponent } from './bank-consents-activity.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DataTableModule } from '@app/core/components/data-table/data-table.module';
import { MaterialModule } from '@app/lib/material.module';
import { ColumnModule } from '@app/main/column/column.module';
import { FilterModule } from '@app/main/filter/filter.module';
import { ListBaseModule } from '@app/main/list-base/list-base.module';
import { SharedTranslateModule } from '@app/shared/shared-translate.module';
import { SharedModule } from '@app/shared/shared.module';
import { EditorModule } from '@tinymce/tinymce-angular';
import { TimelineModule } from '@app/core/components/timeline/timeline.module';
import { BankConsentPermissionsDialogComponent } from '@app/main/identity-reports/banks-info-report/bank-consent-permissions-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { BankTransactionDirectionIconComponent } from '@app/main/identity-reports/banks-info-report/bank-transaction-direction-icon.component';
import { BanksInfoReportComponent } from '@app/main/identity-reports/banks-info-report/banks-info-report.component';
import { IdentityReportsPipesModule } from '@app/main/identity-reports/identity-reports-pipes.module';
import { CreditPipesModule } from '@app/main/credit/credit-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    ColumnModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    ListBaseModule,
    MatExpansionModule,
    FilterModule,
    DataTableModule,
    SharedTranslateModule,
    SharedModule,
    MatProgressSpinner,
    EditorModule,
    DragDropModule,
    MatExpansionModule,
    TimelineModule,
    TranslateModule,
    CreditPipesModule,
  ],
  declarations: [
    BankConsentsActivityComponent,
    BankConsentTimelineActivityEventComponent,
    BankConsentPermissionsDialogComponent,
    BanksInfoReportComponent,
    BankTransactionDirectionIconComponent,
  ],
  exports: [
    BankConsentsActivityComponent,
    BankConsentTimelineActivityEventComponent,
    BankConsentPermissionsDialogComponent,
    BanksInfoReportComponent,
    BankTransactionDirectionIconComponent,
  ],
  providers: [IrisService],
})
export class BankConsentsModule {}
